import { render, staticRenderFns } from "./IssueDocumentUploader.vue?vue&type=template&id=7ee88ce0&scoped=true&"
import script from "./IssueDocumentUploader.vue?vue&type=script&lang=js&"
export * from "./IssueDocumentUploader.vue?vue&type=script&lang=js&"
import style0 from "./IssueDocumentUploader.vue?vue&type=style&index=0&id=7ee88ce0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee88ce0",
  null
  
)

export default component.exports